import React, { useEffect, useState } from "react";
// import prefixNoService from "./user-service";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Navigate, useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
// import ADPUsrService from "../../../../../services/admin/ADPUsrService";

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import prefixNoService from "./prefixno-service";
import BreadcrumbComponent from "../../../../components/Breadcrumb";


const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    fullName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    icNo: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    userId: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
};
const UserList: React.FC = () => {
    const [prefixNoData, setPrefixNoData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const [clientState, setClientState] = useState<any>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await prefixNoService.getClientState();
                setClientState(clientStateItem);
            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

     useEffect(() => {
            if (clientState) {
                const fetchPrefixNoList = async () => {
                    try {
                        const response = await prefixNoService.findAll();
                        setPrefixNoData(response); // Assuming the response is the array of user data
                    } catch (error) {
                        console.error('Error fetching user data:', error);
                    } finally {
                        setLoading(false);
                    }
                };
    
                fetchPrefixNoList();
            }
        }, [clientState]);

    function handlePrint(): void {
        window.print();
    };

    const handleCreate = () => {
        navigate(`/admin/prefix-no-edit`);
    };

    const toolbarLeftTemplate = () => {

        return (
            
            <>
               
                <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.5em' }} onClick={() => handlePrint()} />
                <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} />
            </>
        );
    };
    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters(defaultFilters);
        setGlobalFilterValue('');
    }
    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} /> */}
                <div>
                    {/* <InputIcon className="pi pi-search" /> */}
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </div>
                <div>
                    <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                    <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} />
                    </div>
            </div>
        );
    };

    const header = renderHeader();



    const handleEdit = (item: any) => {
        navigate('/admin/prefix-no-edit', {
            state: { selectItem: item },
        });
    };

    const handleView = (userId: string) => {
        navigate(`/admin/user-view`, {
            state: { userId: userId },
        });
    };

    const handleDelete = (userId: string) => {
        // ADPUsrService.delete(userId).then(() => {
        //     setUsers(users.filter((user: any) => user.user_id !== userId));
        // });
    };

    const actionTemplate = (rowData: any) => (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Button
                label="View"
                icon="pi pi-eye"
                className="p-button-info p-button-sm "
                style={{ padding: '3px 5px', fontSize: '10px' }} 
                onClick={() => handleView(rowData.documentType)}
            />
            <Button
                label="Edit"
                icon="pi pi-pencil"
                className="p-button-warning p-button-sm "
                style={{ padding: '3px 5px', fontSize: '10px' }} 
                onClick={() => handleEdit(rowData)}
            />
           
        </div>
    );

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Prefix No</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='card'>
                    <>
                        <DataTable value={prefixNoData} showGridlines scrollable scrollHeight='auto' paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                            filters={filters} globalFilterFields={['documentType', 'generateType', 'prefix']} header={header}  sortField="modifiedDate"
                            sortOrder={-1} // -1 => descending, 1 => ascending
                        >
                            <Column
                                header="No."
                                style={{ width: '5%' }}
                                body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                            ></Column>
                            <Column field="documentType" header="Prefix Id" style={{ width: '30%' }}></Column>
                            <Column field="generateType" header="Category Type." style={{ width: '20%' }}></Column>
                            <Column field="prefix" header="Prefix" style={{ width: '20%' }}></Column>
                            <Column field="lastNo" header="Last No" style={{ width: '25%' }}></Column>
                            <Column body={actionTemplate} header="Actions" style={{ width: '30%' }} ></Column>

                        </DataTable>
                    </>
                </div>
            </div>
        </div>

    );

};

export default UserList
